/**
 * Skeleton — Platzhalter-Primitive für Ladezustände.
 *
 * Ersetzt nackte „Wird geladen …"-Textzeilen durch ruhige, layout-nahe
 * Platzhalter. `LoadingRows` bündelt mehrere Karten-Skelette in einem
 * `role="status"`-Container mit sr-only-Ladehinweis (Screenreader bekommen
 * den Zustandswechsel mit). Reduzierte Bewegung wird respektiert.
 */

/** Einzelner pulsierender Platzhalter-Block. Größe via `className` (h-/w-). */
export function Skeleton({ className = '' }: { readonly className?: string }) {
  return (
    <span
      aria-hidden="true"
      className={`block animate-pulse rounded-sm bg-stone-200 motion-reduce:animate-none ${className}`}
    />
  );
}

/**
 * Mehrere karten-förmige Zeilen-Skelette (Kicker + Titel + Zeile), passend zu
 * den Listen-/Karten-Layouts (Cases, Mandant-Home). a11y-korrekt: `role=status`
 * + `aria-busy` + sr-only-Label.
 */
export function LoadingRows({
  rows = 3,
  label = 'Wird geladen …',
}: {
  readonly rows?: number;
  readonly label?: string;
}) {
  return (
    <div role="status" aria-busy="true" aria-live="polite" className="space-y-3">
      <span className="sr-only">{label}</span>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="rounded-sm border border-stone-200 bg-white px-6 py-5 md:px-10">
          <Skeleton className="h-3 w-24" />
          <Skeleton className="mt-3 h-5 w-2/3" />
          <Skeleton className="mt-2 h-3 w-1/3" />
        </div>
      ))}
    </div>
  );
}
